module.exports = __webpack_public_path__ + "img/vertical_7_6_8023.48e7f61f.png";